const initialState = {
  configuration: null,
  errors: {},
  error: '',
};

export default function editConfigurationReducer(state = initialState, action) {
  switch (action.type) {
    case 'EDIT_CONFIGURATION_FETCH':
    case 'EDIT_CONFIGURATION_CLEAR':
      return {
        configuration: null,
        errors: {},
        error: '',
      };
    case 'EDIT_CONFIGURATION_ERROR':
      return {
        ...state,
        error: action.error,
      };
    case 'EDIT_CONFIGURATION_SUCCESS':
      return {
        configuration: {
          ...action.configuration,
          permission: true,
          name: action.configuration.name ? action.configuration.name : '',
          integrationProperties: action.configuration.integrationProperties.map(x => ({
            ...x,
            fieldValue: x.fieldValue ? x.fieldValue : '',
          })),
        },
        errors: {},
      };
    case 'EDIT_CONFIGURATION_SET':
      return action.editConfiguration;
    default:
      return state;
  }
}
